var _defs, _rect, _rect2, _rect3, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#231f20;}.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:37.46px;}.cls-3{fill:#ed1c24;}.cls-4{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2000,
    height: 2000
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 346.16,
    y: 493.24,
    width: 1310.54,
    height: 1013.51,
    rx: 94.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 604.81,
    y: 1141.67,
    width: 811.11,
    height: 62.72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M841.56,934.23q0,49.66-13.7,79.85T786.54,1058q-27.6,13.71-77.65,13.7H625.07V796.79h83q48.66,0,77.36,14.11t42.41,44Q841.56,884.79,841.56,934.23Zm-57.8-.39q0-36-7-53.33a44.72,44.72,0,0,0-23.93-24.93q-16.89-7.55-50-7.54H681.28v172.39h21.45q33.16,0,49.95-7.64t23.93-25.53Q783.77,969.4,783.76,933.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M873.36,1071.67l91-274.88h72.89l91.17,274.88H1071l-18.27-55.81H946.85L929,1071.67Zm89.37-104.86h74.09L999.87,853.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1396.56,934.23q0,71.7-30.29,107.45t-88.08,35.75q-61,0-89.68-37.63t-28.7-105.57q0-68.31,28.7-105.76T1278.19,791q61.36,0,89.87,37.44T1396.56,934.23Zm-57.8,0q0-48.86-13.8-71.2t-46.77-22.34q-33,0-46.78,22.34t-13.8,71.2q0,48.87,14,71.21t46.58,22.34q33,0,46.77-22.34T1338.76,934.23Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankless);
export default __webpack_public_path__ + "static/media/bankless.53a417bcf45d94d4988e71c12e866ffd.svg";
export { ForwardRef as ReactComponent };